import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Navbar from './Navbar';
import { Email, Facebook, PhoneIphone } from '@mui/icons-material';
import { useMediaQuery, Box, Typography, Grid } from '@mui/material';
import Divider from '@mui/material/Divider';

  
  function Header() {
    const isMobile = useMediaQuery(theme => theme.breakpoints.down('sm'));
    const isDesktop = useMediaQuery(theme => theme.breakpoints.up('md'));

    return (
      <AppBar position="sticky" sx={{ background: 'white', boxShadow: '1'}}>
      {isDesktop && (
        <Grid container spacing={1} paddingRight={4} paddingLeft={4} justifyContent="space-between"> 
          <Grid item style={{ width: '150px' }} >
            <Box
              sx={{
                width: '240px',
                height: '100px',  // Adjust the height as needed
                alignSelf: 'center',
                backgroundImage: `url('https://tom-house-huc6gadgb3c4cac8.z03.azurefd.net/images/Tom-House.png')`,
                backgroundSize: '120px',
                backgroundPosition: 'left',
                backgroundRepeat: 'no-repeat'
              }}>
            </Box>
          </Grid>
          <Grid item style={{ textAlign: 'center', alignContent: 'center' }} >
            <Box container margin={0} boxShadow={0} padding={4} >
            <Grid container style={{ flexGrow: 1, textAlign: 'center' }}>
              <PhoneIphone fontSize='large' sx={{ mr: 2, color: 'black' }} item xs={2}/>
              <Typography variant="h6" sx={{ color: 'black' }}>+36 20 278 7043</Typography>
              <Divider orientation="vertical" flexItem sx={{ mr: 4, ml : 4 }} />
              <Email fontSize='large' sx={{ mr: 2, color: 'black'}} item xs={2}></Email>
              <Typography variant="h6" sx={{ color: 'black' }}>tomhouse.ev@gmail.com</Typography>
              <Divider orientation="vertical" flexItem sx={{ mr: 4, ml : 4, color: 'black' }} />
              <Facebook fontSize='large' sx={{ mr: 2, color: 'black' }} item xs={2}></Facebook>
              <Typography variant="h6" sx={{ color: 'black' }}><a href="https://www.facebook.com/people/Tom-House/100063736346422/" target="_blank" rel="noopener noreferrer">Tom-House</a></Typography>
            </Grid> 
            </Box>
          </Grid>
          <Grid item style={{ width: '240px' }} >
            <Navbar />   
          </Grid>          
        </Grid>     
    )}
    {isMobile && (
      <Grid container spacing={1} paddingRight={4} paddingLeft={4} justifyContent="space-between"> 
        <Grid item style={{ width: '150px' }} >
          <Box
            sx={{
              width: '150px',
              height: '100px',  // Adjust the height as needed
              alignSelf: 'center',
              backgroundImage: `url('https://tom-house-huc6gadgb3c4cac8.z03.azurefd.net/images/Tom-House.png')`,
              backgroundSize: '120px',
              backgroundPosition: 'left',
              backgroundRepeat: 'no-repeat'
            }}>
          </Box>
        </Grid>
        <Grid item style={{ width: '160px' }} >
          <Navbar />   
        </Grid>
      </Grid>      
    )}
    </AppBar>
  );
}

export default Header;